import { TransactionState } from "types";

interface RefillIdentity {
	id: string;
	state: TransactionState | null | undefined;
}

export interface RefillTransitions {
	isNewRefill: boolean;
	isRefillFinished: boolean;
}

export const getRefillTransitions = (
	prevRefill: RefillIdentity | null,
	incomingRefill: RefillIdentity,
): RefillTransitions => {
	const isSameRefill = prevRefill?.id === incomingRefill.id;
	const isNewRefill = !prevRefill || !isSameRefill;
	const isRefillFinished =
		isSameRefill &&
		prevRefill?.state !== TransactionState.Finished &&
		incomingRefill.state === TransactionState.Finished;

	return { isNewRefill, isRefillFinished };
};
